import { jsx, jsxs } from "react/jsx-runtime";
import { AlignCenter, AlignLeft, AlignRight } from "@tamagui/lucide-icons";
import { Label, ToggleGroup, XStack, YStack } from "tamagui";
function ToggleGroupDemo() {
  return /* @__PURE__ */ jsx(YStack, { paddingHorizontal: "$4", children: /* @__PURE__ */ jsxs(XStack, { alignItems: "center", space: "$10", children: [
    /* @__PURE__ */ jsxs(YStack, { alignItems: "center", space: "$6", children: [
      /* @__PURE__ */ jsx(ToggleGroupComponent, { type: "single", size: "$3", orientation: "horizontal" }),
      /* @__PURE__ */ jsx(ToggleGroupComponent, { type: "multiple", size: "$4", orientation: "horizontal" })
    ] }),
    /* @__PURE__ */ jsxs(XStack, { alignItems: "center", space: "$6", children: [
      /* @__PURE__ */ jsx(ToggleGroupComponent, { type: "single", size: "$3", orientation: "vertical" }),
      /* @__PURE__ */ jsx(ToggleGroupComponent, { type: "multiple", size: "$4", orientation: "vertical" })
    ] })
  ] }) });
}
function ToggleGroupComponent(props) {
  const id = `switch-${props.size.toString().slice(1)}-${props.type}`;
  return /* @__PURE__ */ jsxs(
    XStack,
    {
      flexDirection: props.orientation === "horizontal" ? "row" : "column",
      alignItems: "center",
      justifyContent: "center",
      space: "$4",
      children: [
        /* @__PURE__ */ jsx(Label, { paddingRight: "$0", justifyContent: "flex-end", size: props.size, htmlFor: id, children: props.type === "single" ? "Single" : "Multiple" }),
        /* @__PURE__ */ jsxs(
          ToggleGroup,
          {
            orientation: props.orientation,
            id,
            type: props.type,
            size: props.size,
            disableDeactivation: props.type === "single" ? true : void 0,
            children: [
              /* @__PURE__ */ jsx(ToggleGroup.Item, { value: "left", "aria-label": "Left aligned", children: /* @__PURE__ */ jsx(AlignLeft, {}) }),
              /* @__PURE__ */ jsx(ToggleGroup.Item, { value: "center", "aria-label": "Center aligned", children: /* @__PURE__ */ jsx(AlignCenter, {}) }),
              /* @__PURE__ */ jsx(ToggleGroup.Item, { value: "right", "aria-label": "Right aligned", children: /* @__PURE__ */ jsx(AlignRight, {}) })
            ]
          }
        )
      ]
    }
  );
}
export {
  ToggleGroupDemo
};
//# sourceMappingURL=ToggleGroupDemo.js.map
